import React, { useState, useEffect } from 'react';
import api from '../../utils/apis';
import { useAuth } from '../../contexts/AuthContext';


// Lucide-style SVG Icons
const BankIcons = {
  Building: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 8v-5m0 5h4" />
    </svg>
  ),
  Plus: () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
    </svg>
  ),
  Edit: () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
    </svg>
  ),
  Trash: () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
    </svg>
  ),
  Star: ({ filled = false }) => (
    <svg className="w-4 h-4" fill={filled ? "currentColor" : "none"} stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
    </svg>
  ),
  Eye: () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
    </svg>
  ),
  EyeOff: () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
    </svg>
  ),
  Shield: () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
    </svg>
  ),
  Save: () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
    </svg>
  ),
  X: () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  ),
  Refresh: () => (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
    </svg>
  )
};

const Bank = () => {
  const [banks, setBanks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);
  const [ifscLoading, setIfscLoading] = useState(false);
  const [ifscError, setIfscError] = useState('');

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [showForm, setShowForm] = useState(false);
  const [editingBank, setEditingBank] = useState(null);
  const [formData, setFormData] = useState({
    bank_name: '',
    branch_name: '',
    account_number: '',
    ifsc_code: '',
    account_type: 'Savings',
    is_primary: false
  });

  const { userData } = useAuth();
  const userId = userData?.id;

  useEffect(() => {
    fetchBanks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const fetchBanks = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/customer/bank/${userId}`);
      const banksData = Array.isArray(response.data) ? response.data : [];

      // Transform API data to match component structure
      const transformedBanks = banksData.map(bank => ({
        ...bank,
        bankName: bank.bank_name,
        branchName: bank.branch_name,
        accountNumber: bank.account_number,
        ifscCode: bank.ifsc_code,
        accountType: bank.account_type || 'Savings',
        isPrimary: Boolean(bank.is_primary),
        showAccount: false
      }));

      setBanks(transformedBanks);
      setError('');
    } catch (err) {
      console.error('Error fetching banks:', err);
      setError('Failed to load bank accounts');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    let val = type === 'checkbox' ? checked : value;
    if (name === 'account_number' && typeof val === 'string') {
      val = val.replace(/\D/g, "").slice(0, 18);
    } else if (name === 'ifsc_code' && typeof val === 'string') {
      val = val.replace(/[^A-Za-z0-9]/g, "").toUpperCase().slice(0, 11);
    }
    setFormData(prev => ({
      ...prev,
      [name]: val
    }));

    if (name === 'ifsc_code' && typeof val === 'string') {
      if (val.length === 11) {
        fetchIfscDetails(val);
      } else {
        setIfscError('');
      }
    }
  };

  const fetchIfscDetails = async (ifsc) => {
    setIfscLoading(true);
    setIfscError('');
    try {
      const response = await fetch(`https://ifsc.razorpay.com/${ifsc}`);
      if (!response.ok) {
        throw new Error('Invalid IFSC Code');
      }
      const data = await response.json();
      setFormData(prev => ({
        ...prev,
        bank_name: data.BANK,
        branch_name: data.BRANCH
      }));
    } catch (err) {
      setIfscError('Invalid IFSC Code. Please check and try again.');
      setFormData(prev => ({
        ...prev,
        bank_name: '',
        branch_name: ''
      }));
    } finally {
      setIfscLoading(false);
    }
  };

  const validateForm = () => {
    if (!formData.bank_name?.trim()) return "Bank name is required";
    if (!formData.branch_name?.trim()) return "Branch name is required";
    if (!formData.account_number?.trim()) return "Account number is required";
    if (!formData.ifsc_code?.trim()) return "IFSC code is required";

    if (!/^\d{9,18}$/.test(formData.account_number)) {
      return "Account number must be numeric and between 9 and 18 digits";
    }

    if (!/^[A-Za-z]{4}0[A-Za-z0-9]{6}$/.test(formData.ifsc_code)) {
      return "Enter a valid 11-digit IFSC code (e.g. SBIN0001234)";
    }

    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      return;
    }

    try {
      const payload = {
        user_id: userId,
        bank_name: formData.bank_name,
        account_number: formData.account_number,
        ifsc_code: formData.ifsc_code,
        branch_name: formData.branch_name,
        account_type: formData.account_type,
        is_primary: formData.is_primary
      };

      if (editingBank) {
        // Update existing bank
        await api.put(`/customer/bank/${editingBank.id}`, payload);
      } else {
        // Add new bank
        await api.post('/customer/bank', payload);
      }

      // Refresh the list
      await fetchBanks();
      resetForm();
    } catch (err) {
      console.error('Error saving bank:', err);
      setError('Failed to save bank account');
    }
  };

  const handleEdit = (bank) => {
    setFormData({
      bank_name: bank.bankName,
      branch_name: bank.branchName,
      account_number: bank.accountNumber,
      ifsc_code: bank.ifscCode,
      account_type: bank.accountType,
      is_primary: bank.isPrimary
    });
    setEditingBank(bank);
    setShowForm(true);
  };

  const handleDelete = (id) => {
    setSelectedDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!selectedDeleteId) return;

    try {
      await api.delete(`/customer/bank/delete/${selectedDeleteId}`);
      setBanks(banks.filter(bank => bank.id !== selectedDeleteId));
    } catch (err) {
      console.error('Error deleting bank:', err);
      setError('Failed to delete bank account');
    } finally {
      setShowDeleteModal(false);
      setSelectedDeleteId(null);
    }
  };

  const setAsPrimary = async (id) => {
    try {
      const bank = banks.find(b => b.id === id);
      const payload = {
        user_id: userId,
        bank_name: bank.bankName,
        account_number: bank.accountNumber,
        ifsc_code: bank.ifscCode,
        branch_name: bank.branchName,
        account_type: bank.accountType,
        is_primary: true
      };

      await api.put(`/customer/bank/${id}`, payload);

      // Update local state immediately for better UX
      setBanks(banks.map(b => ({
        ...b,
        isPrimary: b.id === id
      })));

    } catch (err) {
      console.error('Error setting primary bank:', err);
      setError('Failed to set primary bank account');
      // Refresh to get correct state from server
      await fetchBanks();
    }
  };

  const resetForm = () => {
    setFormData({
      bank_name: '',
      branch_name: '',
      account_number: '',
      ifsc_code: '',
      account_type: 'Savings',
      is_primary: false
    });
    setEditingBank(null);
    setShowForm(false);
    setError('');
    setIfscError('');
  };

  const toggleShowAccount = (id) => {
    setBanks(banks.map(bank =>
      bank.id === id
        ? { ...bank, showAccount: !bank.showAccount }
        : bank
    ));
  };

  const maskAccountNumber = (accountNumber) => {
    if (!accountNumber) return '•••• •••• •••• ••••';
    const cleanNumber = accountNumber.toString().replace(/\s/g, '');
    return `•••• •••• •••• ${cleanNumber.slice(-4)}`;
  };

  if (loading) {
    return (
      <div className="view-section p-4">
        <div className="flex justify-between items-start mb-3">
          <div>
            <h2 className="md:text-2xl text-xl font-bold text-gray-900 mb-2">Bank Accounts</h2>
            <p className="text-gray-600 text-sm">Manage your linked bank accounts</p>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
          {[1, 2, 3].map((item) => (
            <div key={item} className="bg-gradient-to-br from-slate-900 to-slate-800  p-5 text-white animate-pulse">
              <div className="flex justify-between items-start mb-4">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-white/10 rounded-lg"></div>
                  <div className="space-y-2">
                    <div className="w-20 h-3 bg-white/20 rounded"></div>
                    <div className="w-24 h-4 bg-white/20 rounded"></div>
                  </div>
                </div>
              </div>
              <div className="space-y-3">
                <div className="w-32 h-5 bg-white/20 rounded"></div>
                <div className="grid grid-cols-2 gap-3">
                  <div className="w-16 h-3 bg-white/20 rounded"></div>
                  <div className="w-16 h-3 bg-white/20 rounded"></div>
                </div>
                <div className="w-24 h-3 bg-white/20 rounded"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="view-section p-4">
      {/* Header */}
      <div className="flex justify-between items-start mb-5">
        <div>
          <h2 className="md:text-2xl text-xl font-bold text-gray-900 mb-1">Bank Accounts</h2>
          <p className="text-gray-600 text-sm">Manage your linked bank accounts</p>
        </div>

        {!showForm && (
          <div className="space-x-3">
            <button
              onClick={() => setShowForm(true)}
              className="text-primary font-bold text-sm px-3 py-2 rounded-lg border border-primary/20 hover:bg-primary/5 transition-colors flex items-center gap-2"
            >
              <BankIcons.Plus />
              <span>Add Bank</span>
            </button>
          </div>
        )}

      </div>

      {error && !showForm && (
        <div className="mb-6 p-4 bg-red-50 rounded-lg border border-red-200 flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-6 h-6 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
              <BankIcons.X className="text-red-600" />
            </div>
            <div>
              <p className="text-red-800 font-medium text-sm">{error}</p>
            </div>
          </div>
          <button
            onClick={fetchBanks}
            className="text-red-600 hover:text-red-800 text-sm font-medium"
          >
            Try Again
          </button>
        </div>
      )}

      {showForm ? (
        /* Add/Edit Form */
        <div className="bg-white md:p-5 p-1  mb-5">
          <div className="flex items-center mb-6">
            <div className="w-10 h-10 bg-blue-50 rounded-lg flex items-center justify-center mr-3">
              <BankIcons.Building />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">
                {editingBank ? 'Edit Bank Account' : 'Add New Bank Account'}
              </h3>
              <p className="text-gray-500 text-sm">Secure and encrypted</p>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  IFSC Code
                </label>
                <div className="relative">
                  <input
                    type="text"
                    name="ifsc_code"
                    value={formData.ifsc_code}
                    onChange={handleInputChange}
                    className={`w-full px-3 py-2.5 border ${ifscError ? 'border-red-300' : 'border-gray-300'} rounded-lg focus:outline-none text-sm uppercase`}
                    placeholder="Enter 11-digit IFSC code"
                    required
                  />
                  {ifscLoading && (
                    <div className="absolute right-3 top-2.5 animate-spin text-gray-400">
                      <BankIcons.Refresh />
                    </div>
                  )}
                </div>
                {ifscError ? (
                  <p className="mt-1 text-xs text-red-500">{ifscError}</p>
                ) : (
                  <p className="mt-1 text-xs text-gray-500">Bank details auto-fill on valid IFSC</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Account Number
                </label>
                <input
                  type="text"
                  name="account_number"
                  value={formData.account_number}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:outline-none text-sm font-mono"
                  placeholder="Enter account number"
                  maxLength="18"
                  required
                />
              </div>

              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Bank Name
                </label>
                <input
                  type="text"
                  name="bank_name"
                  value={formData.bank_name}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:outline-none bg-gray-50 text-sm"
                  placeholder="Bank name (auto-filled)"
                  readOnly
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Branch Name
                </label>
                <input
                  type="text"
                  name="branch_name"
                  value={formData.branch_name}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:outline-none bg-gray-50 text-sm"
                  placeholder="Branch name (auto-filled)"
                  readOnly
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Account Type
                </label>
                <select
                  name="account_type"
                  value={formData.account_type}
                  onChange={handleInputChange}
                  className="w-full px-3 py-2.5 border border-gray-300 rounded-lg focus:outline-none text-sm"
                >
                  <option value="Savings">Savings Account</option>
                  <option value="Current">Current Account</option>
                  <option value="Salary">Salary Account</option>
                </select>
              </div>
            </div>

            <div className="flex items-center p-3 bg-primary/20 rounded-lg border border-primary">
              <input
                type="checkbox"
                name="is_primary"
                checked={formData.is_primary}
                onChange={handleInputChange}
                className="w-4 h-4 text-primary border-primary rounded focus:ring-primary"
                id="primaryBank"
              />
              <label htmlFor="primaryBank" className="ml-3 text-sm font-medium text-primary">
                Set as primary bank account
              </label>
            </div>

            {error && showForm && (
              <div className="p-3 bg-red-50 rounded-lg border border-red-200">
                <p className="text-red-700 text-sm">{error}</p>
              </div>
            )}

            <div className="flex space-x-3 pt-2">
              <button
                type="submit"
                className="bg-primary text-white px-6 py-2.5 rounded-lg font-medium hover:bg-primary/70 transition-all duration-200 flex items-center space-x-2 text-sm"
              >
                <BankIcons.Save />
                <span>{editingBank ? 'Update Account' : 'Add Account'}</span>
              </button>
              <button
                type="button"
                onClick={resetForm}
                className="px-6 py-2.5 border border-gray-300 rounded-lg font-medium text-gray-700 hover:bg-gray-50 transition-all duration-200 flex items-center space-x-2 text-sm"
              >
                <BankIcons.X />
                <span>Cancel</span>
              </button>
            </div>
          </form>
        </div>
      ) : (
        /* Bank Cards Grid */
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-2 gap-4">
          {banks.map((bank) => (
            <div key={bank.id} className="bg-gradient-to-br from-slate-900 to-slate-800  p-5 text-white relative overflow-hidden group hover:shadow-xl transition-all duration-300">
              {/* Primary Badge */}
              {bank.isPrimary && (
                <div className="absolute top-3 right-3 w-6 h-6 bg-yellow-400 rounded-full flex items-center justify-center shadow-lg">
                  <BankIcons.Star filled={true} className="text-slate-900 w-3 h-3" />
                </div>
              )}

              {/* Bank Header */}
              <div className="flex justify-between items-start mb-4 relative z-10">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center backdrop-blur-sm">
                    <BankIcons.Building />
                  </div>
                  <div>
                    <p className="text-gray-300 text-xs font-medium">Bank Name</p>
                    <p className="font-semibold text-sm">{bank.bankName}</p>
                  </div>
                </div>
              </div>

              {/* Account Details */}
              <div className="space-y-3 relative z-10">
                <div>
                  <div className="flex justify-between items-center mb-1">
                    <p className="text-gray-300 text-xs font-medium">Account Number</p>
                    <button
                      onClick={() => toggleShowAccount(bank.id)}
                      className="text-gray-400 hover:text-white transition-colors p-1 rounded"
                    >
                      {bank.showAccount ? <BankIcons.EyeOff /> : <BankIcons.Eye />}
                    </button>
                  </div>
                  <p className="font-mono text-lg tracking-wide font-medium">
                    {bank.showAccount ? bank.accountNumber : maskAccountNumber(bank.accountNumber)}
                  </p>
                </div>

                <div className="grid grid-cols-2 gap-3 text-xs">
                  <div>
                    <p className="text-gray-300 font-medium mb-1">Branch</p>
                    <p className="font-medium">{bank.branchName}</p>
                  </div>
                  <div>
                    <p className="text-gray-300 font-medium mb-1">Account Type</p>
                    <p className="font-medium">{bank.accountType}</p>
                  </div>
                </div>

                <div>
                  <p className="text-gray-300 text-xs font-medium mb-1">IFSC Code</p>
                  <p className="font-mono font-medium tracking-wide text-sm">{bank.ifscCode}</p>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex space-x-2 mt-4 pt-4 border-t border-white/10 relative z-10">
                <button
                  onClick={() => handleEdit(bank)}
                  className="flex-1 bg-white/10 hover:bg-white/20 text-white py-2 rounded-lg font-medium transition-all duration-200 flex items-center justify-center space-x-1 text-xs"
                >
                  <BankIcons.Edit />
                  <span>Edit</span>
                </button>
                <button
                  onClick={() => handleDelete(bank.id)}
                  className="flex-1 bg-red-500/20 hover:bg-red-500/30 text-red-200 py-2 rounded-lg font-medium transition-all duration-200 flex items-center justify-center space-x-1 text-xs"
                >
                  <BankIcons.Trash />
                  <span>Delete</span>
                </button>
                {!bank.isPrimary && (
                  <button
                    onClick={() => setAsPrimary(bank.id)}
                    className="flex-1 bg-yellow-500/20 hover:bg-yellow-500/30 text-yellow-200 py-2 rounded-lg font-medium transition-all duration-200 flex items-center justify-center space-x-1 text-xs"
                  >
                    <BankIcons.Star />
                    <span>Primary</span>
                  </button>
                )}
              </div>

              {/* Background Pattern */}
              <div className="absolute bottom-0 right-0 w-20 h-20 bg-blue-500/5 rounded-full -translate-y-8 translate-x-8"></div>
            </div>
          ))}
        </div>
      )}

      {/* Empty State */}
      {!showForm && banks.length === 0 && (
        <div className="text-center py-12">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <BankIcons.Building />
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">No bank accounts</h3>
          <p className="text-gray-600 text-sm mb-6">Add your first bank account to get started</p>
          <button
            onClick={() => setShowForm(true)}
            className="bg-primary text-white px-6 py-2.5 rounded-lg font-medium hover:bg-primary/80 transition-colors text-sm"
          >
            Add Bank Account
          </button>
        </div>
      )}

      {/* Security Note */}
      {!showForm && banks.length > 0 && (
        <div className="mt-6 p-4 bg-green-50 rounded-lg border border-green-200 flex items-start space-x-3">
          <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
            <BankIcons.Shield className="text-green-600" />
          </div>
          <div>
            <p className="text-green-800 font-medium text-sm">Your data is secure</p>
            <p className="text-green-600 text-xs mt-1">Bank details are encrypted and stored securely. We never share your financial information.</p>
          </div>
        </div>
      )}

      {showDeleteModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-black/40 backdrop-blur-sm"
            onClick={() => setShowDeleteModal(false)}
          />

          {/* Modal */}
          <div className="relative z-10 w-[90%] max-w-sm  bg-white p-5 shadow-xl text-slate-800">
            <h3 className="text-lg font-bold text-gray-800 mb-2">
              Delete Bank Account
            </h3>

            <p className="text-sm text-gray-600 mb-5">
              Are you sure you want to delete this bank account?
            </p>

            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowDeleteModal(false)}
                className="px-4 py-2 rounded-lg border border-gray-300 text-sm hover:bg-gray-50 text-gray-700"
              >
                Cancel
              </button>

              <button
                onClick={confirmDelete}
                className="px-4 py-2 rounded-lg bg-red-500 text-white text-sm font-semibold hover:bg-red-600"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Bank;